import React from 'react';
import Script from 'next/script';

const FriendbuyAuthScript = () => (
  <>
    <Script
      type='text/javascript'
      src='/api/friend-buy-auth'
      strategy='beforeInteractive'
    />
    <Script
      id='friendbuyAuthScript'
      strategy='afterInteractive'
      dangerouslySetInnerHTML={{
        __html: `
      window["friendbuyAPI"] = friendbuyAPI = window["friendbuyAPI"] || [];

      friendbuyAPI.push([
        "auth",
        window.friendbuyAuth.authString,
        window.friendbuyAuth.signature
      ]);
    `,
      }}
    />
  </>
);

FriendbuyAuthScript.propTypes = {};

FriendbuyAuthScript.defaultProps = {};

export default FriendbuyAuthScript;
